import React, { Fragment, useState, useEffect } from 'react';
import {
    Row,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Spinner,
    Modal, ModalHeader,
    ModalBody, ModalFooter, Button
} from 'reactstrap';
import Axios from 'axios';
import WordCloud from 'react-d3-cloud';
import { AxiosAPI, AxiosPublicAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    week,
    month,
    last7Days,
    last30Days,
    last60Days,
    last90Days,
    LastDays,
    year,
} from './lablesConfig';
import {
    gAPI_Messenger_Click,
    gAPI_Topics_Stats,
    gAPI_Service_Click
} from '../../../../../constants/APIs';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import ReactHtmlParser from 'react-html-parser';
export default function WordClouds({
    propertyId,
    isComendiumConnect,
    timeZone,
    domains,
    currency,
    history,
    integrationIdList
}) {
    moment.tz.setDefault(timeZone);
    const [buttonText, setButtonText] = useState(
        <IntlMessages id="dashboards.last-7-days" />
    );
    const [labels, setLabels] = useState(last7Days);
    const [isShow, setIsShow] = useState(false);
    const [isError, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [filterDate, setFilterDate] = useState(false);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [itemClickData, setItemClickData] = useState([]);
    const [aiChatBotCloud, setAiChatBotCloud] = useState([]);
    const [compendiumWordCloud, setCompendiumWordCloud] = useState();
    const today = () => {
        return moment(moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const daysAgo7 = () => {
        return moment(moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-D 00:00:00');
    };

    const daysAgo30 = () => {
        return moment(moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo60 = () => {
        return moment(moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo90 = () => {
        return moment(moment().subtract(90, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfWeek = () => {
        const today = moment();
        return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const endOfWeek = () => {
        const today = moment();
        return moment(
            moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfMonth = () => {
        return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
            ' 00:00:00'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfThisYear = () => {
        return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const startOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
            ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const endOfMonth = () => {
        return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const handleStartDate = (date) => {
        setStartDate(date)
    };

    const handleEndDate = (date) => {
        setEndDate(date)
    };


    useEffect(() => {
        if (propertyId !== '' && propertyId !== undefined) {
            selectLast7Days();

        }
    }, [propertyId]);

    const createWordCloud = (val) => {
        setAiChatBotCloud([]);
        let word = [];
        val.map(m => {
            if (word.filter(f => f.text === m.name).length == 0)
                word.push({ text: m.name, value: getFontSize(m.count) }
                )
        });
        setAiChatBotCloud(word);
    }

    const createCompendiumWordCloud = (val) => {

        setCompendiumWordCloud([]);
        let word = [];
        val.map(m => {
            if (word.filter(f => f.text === m.name).length == 0)
                word.push({ text: m.name, value: getFontSize(m.count) }
                )
        });
        setCompendiumWordCloud(word);
    }

    const getFontSize = (val) => {
        if (val < 10)
            return 5;
        else if (val > 10 && val < 50)
            return 9 + ((val % 10) > 5 ? (val % 10) / 2 : (val % 10) / 3)
        else if (val > 50 && val < 100)
            return 12 + ((val % 10) > 5 ? (val % 10) / 2 : (val % 10) / 3)
        else if (val > 100)
            return 15 + ((val % 10) > 5 ? (val % 10) / 2 : (val % 10) / 3)
    }

    const selectLast7Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-7-days" />);
        setLabels(last7Days);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo7(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: daysAgo7(),
                        dateTo: today(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo7(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectLast30Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-30-days" />);
        setLabels(last30Days);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo30(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: daysAgo30(),
                        dateTo: today(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo30(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectLast60Days = () => {
        setButtonText(<IntlMessages id="dashboards.last-60-days" />);
        setLabels(last60Days);
        setFilterDate(false);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo60(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: daysAgo60(),
                        dateTo: today(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo60(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectLast90Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-90-days" />);
        setLabels(last90Days);

        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo90(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: daysAgo90(),
                        dateTo: today(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: daysAgo90(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectThisWeek = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.this-week" />);
        setLabels(week);

        Axios.all([

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfWeek(),
                    dateTo: endOfWeek(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startOfWeek(),
                        dateTo: endOfWeek(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfWeek(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const handleFilterDateWise = (startDate, endDate) => {

        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startDate,
                    dateTo: endDate,
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startDate,
                        dateTo: endDate,
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startDate,
                    dateTo: endDate,
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectThisMonth = () => {
        setButtonText(<IntlMessages id="dashboards.this-month" />);
        setLabels(month);
        setFilterDate(false);

        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfMonth(),
                    dateTo: endOfMonth(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startOfMonth(),
                        dateTo: endOfMonth(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfMonth(),
                    dateTo: endOfMonth(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectPreviousMonth = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.previous-month" />);
        setLabels(month);

        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfPreviousMonth(),
                    dateTo: endOfPreviousMonth(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startOfPreviousMonth(),
                        dateTo: endOfPreviousMonth(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfPreviousMonth(),
                    dateTo: endOfPreviousMonth(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectThisYear = () => {
        setButtonText(<IntlMessages id="dashboards.yeartodate" />);
        setLabels(year);
        setFilterDate(false);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfThisYear(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startOfThisYear(),
                        dateTo: today(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfThisYear(),
                    dateTo: today(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };

    const selectLastYear = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.lastyear" />);
        setLabels(year);

        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfLastYear(),
                    dateTo: endOfLastYear(),
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startOfLastYear(),
                        dateTo: endOfLastYear(),
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startOfLastYear(),
                    dateTo: endOfLastYear(),
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),
        ]);
    };


    const handleFilterMonthWise = (startDate, endDate) => {
        setLabels(year);
        Axios.all([
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Messenger_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startDate,
                    dateTo: endDate,
                    lang: "en"
                },
            }).then((res) => {
                setItemClickData(res.data);
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Topics_Stats}`,
                    params: {
                        groupId: getGroupID(),
                        propertyId: propertyId,
                        dateFrom: startDate,
                        dateTo: endDate,
                        lang: "en"
                    },
                }).then((json) => {
                    let words = [];
                    if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                        res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                    }
                    if (json.data !== undefined && json.data.length > 0) {
                        json.data.map(m => words.push({ name: m?.topic, count: m?.messages }));
                    }
                    if (words.length > 0)
                        createWordCloud(words);
                });
            }),
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Service_Click}`,
                params: {
                    groupId: getGroupID(),
                    propertyId: propertyId,
                    dateFrom: startDate,
                    dateTo: endDate,
                    lang: "en"
                },
            }).then((res) => {
                let words = [];
                if (res.data.itemClicks !== undefined && res.data.itemClicks.length > 0) {
                    res.data.itemClicks.map(m => words.push({ name: m?.title, count: m?.clicks }));
                }
                if (words.length > 0)
                    createCompendiumWordCloud(words);
            }),

        ]);
    }
    const handleFilter = () => {
        let diff = endDate.diff(startDate, 'days');
        setButtonText('Date Range');
        if (diff > 365) {
            setMessage("The start and end date must be within a year of each other.");
            setError(true);
            return;
        }
        if (diff > 90) {
            setIsShow(false);
            setLabels(year);
            handleFilterMonthWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);

        } else {
            if (diff >= 60)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 30)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 7)
                setLabels(LastDays(startDate, endDate));
            else
                setLabels(LastDays(startDate, endDate));
            setIsShow(false);
            handleFilterDateWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);
        }
    };

    return (
        <Fragment>
            <Row>
                <Col xxs="12" className="mb-2">
                    <Fragment>
                        {filterDate === true && <div className='float-left mt-2'>
                            <span className='mr-2'><b>From : </b>{moment(startDate).format('DD')}/{moment(startDate).format('MM')}/{moment(startDate).format('YYYY')}</span>
                            <span className='ml-2'><b>To : </b>{moment(endDate).format('DD')}/{moment(endDate).format('MM')}/{moment(endDate).format('YYYY')}</span>
                        </div>}
                        <div className="btn-group float-right float-none-xs mb-3">
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    color="primary"
                                    className="btn-xs"
                                    outline
                                >
                                    {buttonText}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={selectLast7Days}>
                                        <IntlMessages id="dashboards.last-7-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast30Days}>
                                        <IntlMessages id="dashboards.last-30-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast60Days}>
                                        <IntlMessages id="dashboards.last-60-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast90Days}>
                                        <IntlMessages id="dashboards.last-90-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisWeek}>
                                        <IntlMessages id="dashboards.this-week" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisMonth}>
                                        <IntlMessages id="dashboards.this-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectPreviousMonth}>
                                        <IntlMessages id="dashboards.previous-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisYear}>
                                        <IntlMessages id="dashboards.yeartodate" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLastYear}>
                                        <IntlMessages id="dashboards.lastyear" />
                                    </DropdownItem>
                                    <DropdownItem onClick={() => setIsShow(!isShow)}>
                                        Date Range
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </Fragment>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="12" className="mb-4">
                    <Card className={`dashboard-filled-line-chart`} style={{ height: '700px' }}>
                        <div style={{ padding: '15px', paddingTop: '8px' }}>
                            <div className="float-left float-none-xs">
                                <div className="d-inline-block">
                                    <h5 className="d-inline">
                                        Commonly Asked Questions & Popular Menu Items
                                    </h5>
                                    <span className="text-muted text-small d-block">
                                        Word Cloud on Things Website Visitors Are Asking About & Menu Items
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="chart card-body pt-0 text-center">
                            {(aiChatBotCloud !== undefined && aiChatBotCloud.length > 0) &&
                                <WordCloud
                                    data={aiChatBotCloud}
                                    width={500}
                                    height={150}
                                    fill="gray"
                                    rotate={0}
                                    font="Times"
                                    fontSize={(word) => word.value}
                                    spiral="rectangular"
                                />}
                        </div>
                    </Card>

                </Col>
            </Row>
            {(isComendiumConnect !== undefined && isComendiumConnect === true) &&
                <Row>
                    <Col sm="12" md="12" className="mb-4">
                        <Card className={`dashboard-filled-line-chart`} style={{ height: '700px' }}>
                            <div style={{ padding: '15px', paddingTop: '8px' }}>
                                <div className="float-left float-none-xs">
                                    <div className="d-inline-block">
                                        <h5 className="d-inline">
                                            Popular Compendium Menu Items
                                        </h5>
                                        <span className="text-muted text-small d-block">
                                            Word Cloud of Compendium Menu Item
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="chart card-body pt-0 text-center">
                                {(compendiumWordCloud !== undefined && compendiumWordCloud.length > 0) &&
                                    <WordCloud
                                        data={compendiumWordCloud}
                                        width={500}
                                        height={150}
                                        fill="gray"
                                        rotate={0}
                                        font="Times"
                                        fontSize={(word) => word.value}
                                        spiral="rectangular"
                                    />}
                            </div>
                        </Card>

                    </Col>
                </Row>
            }

            <Modal isOpen={isShow}
                toggle={() => setIsShow(!isShow)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setIsShow(!isShow)}>
                    Date Range
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label>Start Date</Label>
                                <DatePicker
                                    style={{ borderRadius: '10px' }}
                                    selected={startDate}
                                    onChange={handleStartDate}
                                    placeholderText="Start Date"
                                    dateFormat="DD/MM/YYYY"
                                />
                            </FormGroup>
                        </Colxx>

                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label>End Date</Label>
                                <DatePicker
                                    style={{ borderRadius: '10px' }}
                                    selected={endDate}
                                    onChange={handleEndDate}
                                    placeholderText="End Date"
                                    dateFormat="DD/MM/YYYY"
                                />
                            </FormGroup>
                        </Colxx>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={() => handleFilter()}>Submit</Button>
                    <Button className="ml-2" onClick={() => setIsShow(!isShow)}>Close</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isError}
                toggle={() => setError(!isError)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setError(!isError)}>
                    BOOKMEBOB
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <p className='m-2'>{message}</p>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button className="ml-2" onClick={() => setError(!isError)}>Close</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}